<div class="common-popup-container add-filter-wrapper">
    <img src="assets/images/new-set/thin-cancel.svg" alt="" class="close">
    <h3 class="title">Add Filter Name</h3>
    <div class="my-input-group mt-4 mb-3">
        <label for="">Enter filter name</label>
        <input type="text" placeholder="Enter name">
    </div>
    <div class="my-input-group">
        <label for="">Display option</label>
        <ng-select class="multiple" multiple="true"
            bindLabel="name" bindValue="id" [clearable]="false"
            placeholder="Select"></ng-select>
    </div>
    <div class="column text-right cta-container mt-4">
        <button class="primary-cta">Save</button>
    </div>
</div>